import { useCallback, useContext } from "react";
import { ConfirmationDialogContext } from "../ContextsAndProvider/ConfirmDialog";

export const useConfirmDialog = () => {
    const { openDialog, resetDialog } = useContext(ConfirmationDialogContext);

    const getConfirmation = useCallback(
        ({ ...options }) =>
            new Promise((res) => {
                openDialog({ actionCallback: res, ...options });
            }),
        [openDialog]
    );

    const closeConfirmation = useCallback(() => {
        resetDialog();
    }, [resetDialog]);

    return { getConfirmation, closeConfirmation };
};